export enum RecommendationVisitedList {
    WISHLIST = "💫  Want To Go",
    BEEN = "✅ Been"
}

export enum RecommendationReviewList {
    BAD = "👎  Not a fan",
    LIKED = "👍  Liked",
    LOVED = "😍  Loved"
  }